import { Box, Button, Card, Flex, Heading, Text } from "@radix-ui/themes";

export default function Login() {
  const handleLogin = () => {
    window.location.assign("/api/v1/sso/login");
  };

  return (
    <Flex align="center" justify="center" style={{ minHeight: "70vh", padding: 24 }}>
      <Card size="3" style={{ width: "100%", maxWidth: 420 }}>
        <Flex direction="column" gap="4">
          <Heading size="5">Sign in</Heading>
          <Text color="gray">
            Use your AMA account to access the AI Coach.
          </Text>

          <Box mt="2">
            <Button size="3" onClick={handleLogin} style={{ width: "100%" }}>
              Log in with AMA
            </Button>
          </Box>

          <Text size="1" color="gray" style={{ marginTop: 8 }}>
            If you can’t sign in, contact your administrator.
          </Text>
        </Flex>
      </Card>
    </Flex>
  );
}
